import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-scroll";
import logoAsset from "../../assets/Initials.png";
import { FaGithub } from "react-icons/fa";
import { AiOutlineLinkedin } from "react-icons/ai";
import { CiMobile3 } from "react-icons/ci";
import { MdOutlineMailOutline } from "react-icons/md";

const SOCIAL_ICON_PX = 32;

const navLinks = [
  { to: "Home", label: "Home" },
  { to: "About", label: "About" },
  { to: "skills", label: "Skills" },
  { to: "experience", label: "Experience" },
  { to: "projects", label: "Projects" },
  { to: "education", label: "Education" },
];

const socialLinks = [
  { href: "tel:548-333-0997", icon: <CiMobile3 size={SOCIAL_ICON_PX} color="#FFFFFF" />, external: false },
  { href: "https://github.com/Code2voyager", icon: <FaGithub size={SOCIAL_ICON_PX} color="#FFFFFF" />, external: true },
  { href: "https://www.linkedin.com/in/nidhis224/", icon: <AiOutlineLinkedin size={SOCIAL_ICON_PX} color="#FFFFFF" />, external: true },
  { href: "mailto:nidhi1709shetty@gmail.com", icon: <MdOutlineMailOutline size={SOCIAL_ICON_PX} color="#FFFFFF" />, external: true },
];

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navShellRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (navShellRef.current && !navShellRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isMenuOpen]);

  const linkClass =
    "cursor-pointer text-sm font-medium text-slate-200/90 hover:text-sky-200 transition-colors duration-200 tracking-wide leading-none";

  return (
    <nav
      className="sticky top-0 z-50 border-b border-white/[0.08] bg-[#0b0918]/92 backdrop-blur-xl shadow-[0_8px_32px_-12px_rgba(15,23,42,0.85)]"
      aria-label="Primary"
    >
      <div
        ref={navShellRef}
        className="max-w-screen-xl mx-auto flex flex-wrap justify-between items-center gap-2 p-3 md:px-6 md:py-3.5 relative"
      >
        <div className="flex items-center shrink-0">
          <Link
            to="Home"
            smooth={true}
            duration={500}
            spy={true}
            offset={-8}
            className="flex items-center cursor-pointer"
            href="#"
            aria-label="Go to home section"
          >
            <img
              src={logoAsset}
              alt=""
              width={64}
              height={64}
              decoding="async"
              fetchPriority="high"
              className="h-12 w-12 shrink-0 object-contain sm:h-14 sm:w-14 md:h-16 md:w-16"
            />
          </Link>
        </div>

        <div className="hidden md:flex flex-1 justify-center items-center gap-5 lg:gap-8 px-3">
          {navLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              smooth={true}
              duration={500}
              spy={true}
              activeClass="text-sky-300 underline decoration-sky-400/60 underline-offset-8 decoration-2"
              className={linkClass}
              href="#"
            >
              {label}
            </Link>
          ))}
        </div>

        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          type="button"
          className="inline-flex md:hidden h-11 w-11 shrink-0 items-center justify-center self-center text-sky-300/90 rounded-lg
          hover:bg-sky-500/10 focus:outline-none focus:ring-2 focus:ring-sky-400/35"
          aria-controls="navbar-default"
          aria-expanded={isMenuOpen ? "true" : "false"}
        >
          <span className="sr-only">Open main menu</span>
          <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <div
          className={`w-full md:w-auto md:flex md:items-center md:justify-end ${
            isMenuOpen
              ? "flex flex-col border-t border-white/10 pt-3 mt-1 md:border-0 md:pt-0 md:mt-0"
              : "hidden md:flex"
          }`}
        >
          <div className="flex flex-col md:flex-row items-stretch md:items-center gap-1 md:gap-0 pb-2 md:pb-0">
            <div className="flex flex-col md:hidden gap-0.5 mb-3">
              {navLinks.map(({ to, label }) => (
                <Link
                  key={to}
                  to={to}
                  smooth={true}
                  duration={500}
                  spy={true}
                  onClick={() => setIsMenuOpen(false)}
                  className={`${linkClass} py-2.5 px-2 rounded-lg`}
                  href="#"
                >
                  {label}
                </Link>
              ))}
            </div>
            <div className="flex flex-row flex-wrap justify-center md:justify-end items-center gap-3 md:gap-4 md:pl-2 [&_svg]:block">
              {socialLinks.map((item, index) => (
                <a
                  href={item.href}
                  {...(item.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                  key={index}
                  className="hover:opacity-90 transition-opacity"
                  aria-label={
                    item.href.startsWith("tel:")
                      ? "Phone"
                      : item.href.startsWith("mailto:")
                        ? "Email"
                        : "Social profile"
                  }
                >
                  <span className="md:hover:scale-110 inline-block transition-transform duration-200">{item.icon}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
